<template>
<div class="container-fluid px-0" style="overflow: hidden;">
  <loader v-if="loadershow"></loader>
  <navbarLogin></navbarLogin>
  <div class="row">
    <div class="col-lg-2 col-md-2 col-sm-2 col-2 pl-0">
      <!-- <img src="../assets/Rectangle.png" class="leftImage" /> -->
    </div>
    <div class="col-lg-8 col-md-8 col-sm-8 col-8">
      <div class="row justify-content-center h-100">
        <div class="col-lg-8 card col-md-8 col-sm-12 col-12 shadow mediaQuery" style="border-radius: 10px; height: fit-content;margin-top: 100px;background: white;">
          <div class="signup pl-2 pt-2">Forgot Password</div>
          <hr />
          <div v-if="content=='forgotPassword'">
            <form class="col-sm-6">
              <div class="">
                <label class="labelFont">Enter Email i'd</label>
                <input
                  v-model="email"
                  type="email"
                  class="form-control"
                  id="loginEMail"
                  @change="validateEmail"
                  placeholder="Email"
                  required/>
                <span v-if="!isvalidEmail" id="warningText"><i class="fa fa-times-circle"></i> {{emailMessage}}</span>
              </div>
            </form>
            <div class="row p-5" style="padding-right: 20px !important">
              <div class="button col-sm-6 ml-auto text-right">
                <span class="already mr-4" @click="pushTologin">Cancel</span>
                <button type="button"
                  class="btn btn-primary signupbtn"
                    @click="ForgotPassword">Confirm</button>
              </div>
            </div>
          </div>
          <div v-else>
            <div style="text-align: center;">
              <span style="colors: #1EA463"><img style="height: 70px" src="../assets/Group 14.svg" /></span>
              <p style="color: #1EA463;" class="sucessText mt-3">PASSWORD CHANGE SUCCESSFUL</p>
              <P class="ff" style="width: 68%; display: inline-block"
                >Email confirmation sent to {{email}}.
                Please confirm to start using new password</P>
                <br />
              <button type="button"
                  @click="pushTologin"
                  class="btn mb-4 mt-2 btn-primary signupbtn"
                  >Back To login</button>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-2 col-md-2 mt-auto col-sm-2 col-2">
      <!-- <img src="../assets/Path 2.png" class="rightImage" style="pointer-events: none;" /> -->
    </div>
  </div>
</div>
</template>
<script>
/* eslint-disable */
import Toasted from 'vue-toasted'
import axios from 'axios'
import Vue from 'vue'
import { settings } from '@/settings'
import navbarLogin from './navbarLogin'
import loader from './loader'
import $ from 'jquery'

Vue.use(Toasted)
export default {
  data() {
    return {
      content: 'forgotPassword',
      email: '',
      password: '',
      isvalidEmail: true,
      emailMessage: '',
      loadershow: false
    }
  },
  components: {
    navbarLogin,
    loader
  },
  methods: {
    ForgotPassword() {
      this.loadershow = true
      axios.post(`${settings.API_SERVER}user/reset`, { email: this.email, url: window.location.href.replace('forgot-password', 'change-password') })
        .then((response) => {
          this.loadershow = false
          this.content = 'mail sent'
          this.$toasted.show(`mail sent on your mail i'd`, { duration: 2000 })
        })
        .catch((err) => {
          console.log('error', err)
        })
    },
    pushTologin() {
      this.$router.push('/login')
    },
    validateEmail() {
      /* eslint-disable */
      // use regex for email validation properly
      var field = /^(([^<>()\[\]\\.,:\s@"]+(\.[^<>()\[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      // var failedValidation = this.email.indexOf('@') === -1
      if (!field.test(this.email)) {
        this.isvalidEmail = false
        this.emailMessage = 'Enter valid email'
        $('#email').css('border-color','red')
      } else {
        this.isvalidEmail = true
        $('#email').css('border-color','#ced4da')
        // this.isEmail = true
      }
    }
  }
}
</script>
<style scoped>
.signup {
  font-family: "Ubuntu";
  font-weight: 500;
  font-size: 34px;
  color: #3b3b3b;
  text-align: left;
  /* margin-top: 25%; */
}
.getstarted,.invalid {
  opacity: 0.7;
  font-family: Ubuntu;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
  line-height: 24px;
}
label {
  font-family: Ubuntu;
  font-weight: 400;
  font-size: 12px;
  color: #606060;
  padding-left: 5px;
  padding-right: 5px;
}
.signupbtn {
  background: #2295c8;
  border-radius: 30px;
  width: 113px;
  height: 44px;
  font-family: ubuntu;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  border: none;
}

.signupbtn:hover {
  background: #2295c8;
}
.img-container {
  margin-top: 20%;
  width: 100%;
}
.form-group > label {
  position: relative;
  left: 19px;
  top: 15px;
  background: white;
}
.input {
  padding-top: 2px;
  font-family: ubuntu;
  font-weight: 300;
  color:white;
}

.already {
  font-family: "Ubuntu";
  font-weight: 500;
  font-size: 14px;
  color: #2295c8;
  line-height: 20px;
  margin-left: 5%;
  cursor: pointer;
}
#warningText {
  color: red;
  opacity: 0.7;
  font-size: 12px;
  font-family: "Ubuntu";
}
.leftImage {
  transform: rotate(180deg);
  /* margin-top: -270px; */
  margin-top: -270px;
  margin-left: -29px;
}
.rightImage {
  -webkit-transform: rotateY(218deg);
      position: absolute;
    bottom: -64px;
    right: -132px;
}
.labelFont {
font-family: "Ubuntu";
font-weight: 500;
font-size: 14px;
color: #9A9A9A;
}
.sucessText {
  font-weight: 700;
  font-family: "Ubuntu";
  font-size: 20px;
  text-align: center;
  line-height: 20px;
}
.ff {
  font-family: "Ubuntu";
}
@media screen and (max-width: 34em) {
  .mediaQuery {
    margin-top: 55px !important;
  }
}
</style>
